const WHITE = [242, 238, 230];
const BLUE = [42, 82, 190];
const YELLOW = [248, 199, 28];
const SEAM = [26, 26, 30];

const PALETTES = [
  [BLUE, WHITE, WHITE],
  [YELLOW, WHITE, BLUE],
  [YELLOW, WHITE, YELLOW],
  [BLUE, YELLOW, BLUE],
  [WHITE, WHITE, BLUE],
  [WHITE, YELLOW, WHITE],
];

function colorAt(p) {
  const a = [Math.abs(p[0]), Math.abs(p[1]), Math.abs(p[2])];
  let d = 0;
  if (a[1] > a[d]) d = 1;
  if (a[2] > a[d]) d = 2;
  const positive = p[d] > 0;
  const faceIdx = d * 2 + (positive ? 0 : 1);
  const s = (d + (positive ? 1 : 2)) % 3;
  const t = p[s] / a[d];
  let strip = Math.floor(((t + 1) / 2) * 3);
  if (strip > 2) strip = 2;
  if (strip < 0) strip = 0;
  let color = PALETTES[faceIdx][strip];
  const stripSeam = Math.min(Math.abs(t + 1 / 3), Math.abs(t - 1 / 3));
  const sorted = [...a].sort((m, n) => n - m);
  if (stripSeam < 0.028 || sorted[0] - sorted[1] < 0.012) color = SEAM;
  return color;
}

export default function makeBallSprite(size = 256) {
  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext("2d");
  const img = ctx.createImageData(size, size);
  const data = img.data;
  const R2 = 0.94;
  let light = [0.5, 0.55, 0.67];
  const llen = Math.hypot(...light);
  light = light.map((c) => c / llen);
  const rx = 0.45;
  const ry = 0.5;
  const rz = -0.1;

  for (let j = 0; j < size; j++) {
    for (let i = 0; i < size; i++) {
      const u = ((i + 0.5) / size) * 2 - 1;
      const v = 1 - ((j + 0.5) / size) * 2;
      const rr = u * u + v * v;
      const idx = (j * size + i) * 4;
      if (rr > R2) {
        data[idx + 3] = 0;
        continue;
      }
      const z = Math.sqrt(R2 - rr);
      const nl = Math.hypot(u, v, z);
      const n = [u / nl, v / nl, z / nl];

      let [x, y, zz] = n;
      let y2 = y * Math.cos(rx) - zz * Math.sin(rx);
      let z2 = y * Math.sin(rx) + zz * Math.cos(rx);
      let x2 = x * Math.cos(ry) + z2 * Math.sin(ry);
      z2 = -x * Math.sin(ry) + z2 * Math.cos(ry);
      const x3 = x2 * Math.cos(rz) - y2 * Math.sin(rz);
      const y3 = x2 * Math.sin(rz) + y2 * Math.cos(rz);

      const c = colorAt([x3, y3, z2]);
      const lam = Math.max(0.2, n[0] * light[0] + n[1] * light[1] + n[2] * light[2]);
      const spec = Math.max(0, lam - 0.84) * 2.4;
      for (let k = 0; k < 3; k++) {
        data[idx + k] = Math.min(255, Math.round(c[k] * (0.35 + 0.75 * lam) + 255 * spec));
      }
      data[idx + 3] = Math.min(1, (R2 - rr) * size * 0.5) * 255;
    }
  }

  ctx.putImageData(img, 0, 0);
  return canvas;
}
